// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function biometriaClear(): ReducerAction {
	return {
		type: Types.BIOMETRIA_CLEAR,
		payload: null,
	};
}
